// A task can contain older submissions. Only the responses committed by this
// wizard determine when its conversion/marking screens may finish.
export const batchStatus = (status, submissionIds) => {
  if (!submissionIds?.length || !status) return status;
  const wanted = new Set(submissionIds);
  return {
    ...status,
    submissions: (status.submissions || []).filter((row) =>
      wanted.has(row.submissionId || row.id),
    ),
  };
};
export const hasAllBatchRows = (status, submissionIds) =>
  Boolean(status) && (!submissionIds?.length ||
    new Set((status.submissions || []).map((row) => row.submissionId || row.id)).size ===
      new Set(submissionIds).size);
